var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDriverLicense(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.25 11H18",
    stroke: "#524F4E",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.25 14H18",
    stroke: "#524F4E",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.63428 14C9.87692 14 10.8843 12.9926 10.8843 11.75C10.8843 10.5074 9.87692 9.5 8.63428 9.5C7.39164 9.5 6.38428 10.5074 6.38428 11.75C6.38428 12.9926 7.39164 14 8.63428 14Z",
    stroke: "#524F4E",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M5.72803 16.25C5.89325 15.6047 6.26855 15.0327 6.79476 14.6242C7.32097 14.2158 7.96815 13.9941 8.63428 13.9941C9.30041 13.9941 9.94759 14.2158 10.4738 14.6242C11 15.0327 11.3753 15.6047 11.5405 16.25",
    stroke: "#524F4E",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M20.25 5H3.75C3.33579 5 3 5.33579 3 5.75V19.25C3 19.6642 3.33579 20 3.75 20H20.25C20.6642 20 21 19.6642 21 19.25V5.75C21 5.33579 20.6642 5 20.25 5Z",
    stroke: "#524F4E",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDriverLicense);
export default __webpack_public_path__ + "static/media/driver_license.15af4becf0d6fa363241bfd7d5babab2.svg";
export { ForwardRef as ReactComponent };